import React from 'react'
import Container from './container'
export default React.memo(Container)
